import type { AxiosResponse } from "axios"

import { ITokenInfo } from "~/types/global"
import type { LibraryProcessResponseData } from "~/utils/file-validation"
import { axiosInstance } from "~/utils/axios"

export async function getKnowledgeOSChatHistory(tokenInfo: ITokenInfo) {
  return await axiosInstance({
    method: "GET",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/sessions?feature=GPT,AGENT`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`,
      "Content-Type": "application/json"
    }
  })
}

export async function getKnowledgeOSSessionHistory(
  tokenInfo: ITokenInfo,
  sessionId: string
) {
  return await axiosInstance({
    method: "GET",
    url: `tenant/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/chatbot/session/${sessionId}/history`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`,
      "Content-Type": "application/json"
    }
  })
}

export async function getSignedUrls(
  tokenInfo: ITokenInfo,
  data: {
    type: string
    filesConfig: {
      name: string
      divisions: string[]
    }[]
  }
) {
  return await axiosInstance({
    method: "POST",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/library/upload`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`,
      "Content-Type": "application/json"
    },
    data
  })
}

export async function processFiles(
  tokenInfo: ITokenInfo,
  data: {
    fileIds: string[]
    type: string
  }
): Promise<
  AxiosResponse<{
    success: boolean
    data: LibraryProcessResponseData | null
    error: string | null
  }>
> {
  return await axiosInstance({
    method: "POST",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/library/process`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`,
      "Content-Type": "application/json"
    },
    data
  })
}

export async function addTags(
  tokenInfo: ITokenInfo,
  data: {
    type: string
    name: string
  }
) {
  return await axiosInstance({
    method: "PUT",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/tags`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`,
      "Content-Type": "application/json"
    },
    data
  })
}

export async function deleteTags(
  tokenInfo: ITokenInfo,
  data: {
    type: string
    tagId: number
  }
) {
  return await axiosInstance({
    method: "DELETE",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/tags/${data?.tagId}/?type=${data?.type}`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`,
      "Content-Type": "application/json"
    }
  })
}

export async function updateTags(
  tokenInfo: ITokenInfo,
  data: {
    type: string
    name: string
  },
  tagId: number
) {
  return await axiosInstance({
    method: "POST",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/tags/${tagId}`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`,
      "Content-Type": "application/json"
    },
    data
  })
}
